import { createStructuredSelector } from 'reselect';

const selectAlert = (state) => state.alert?.alert;
const selectShowAlert = (state) => state.alert?.show;

export default createStructuredSelector({
  alert: selectAlert,
  show: selectShowAlert,
});
